module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function (fox) {
  fox.registerWidget(
    "SitePage_Account",
    {
      configure: function (options) {
        this.registerOptions("", {
          widgets: {
            changePasswordApi: {
              widget: "Api",
              method: "user.changePassword",
            },
            settingsForm: {
              widget: "DomForm",
              formSelector: "#settings-form",
              elements: {
                oldPassword: {
                  validators: [
                    {
                      validator: "length",
                      options: { min: 2 },
                      message: "Password must contain at least 2 characters",
                    },
                  ],
                },
                newPassword: {
                  validators: [
                    {
                      validator: "length",
                      options: { min: 6 },
                      message: "Password must contain at least six characters",
                    },
                    (value) =>
                      !/^(?!.*[\\\/#"]).*$/i.test(value)
                        ? {
                            result: false,
                            message:
                              "The password can't contain special characters \\ / # \" .",
                          }
                        : { result: true },
                  ],
                },
                newPasswordCheck: {
                  validators: [
                    {
                      validator: "length",
                      options: { min: 6 },
                      message: "Password must contain at least six characters",
                    },
                    (value) =>
                      !/^(?!.*[\\\/#"]).*$/i.test(value)
                        ? {
                            result: false,
                            message:
                              "The password can't contain special characters \\ / # \" .",
                          }
                        : { result: true },
                  ],
                },
              },
              handleWom: {
                validate: {
                  event: ["form_not_valid", "form_valid"],
                  widget: "@this",
                  callback: "@parent:_validate",
                },
                submit: {
                  event: "submit",
                  widget: "@this",
                  callback: "@parent:_submit",
                },
              },

              handleDom: {
                focus: {
                  target: 'input[type="password"]',
                  event: "focus",
                  callback: "@parent:_focus",
                },
                submit: {
                  event: "submit",
                  target: "#settings-form",
                },
              },
            },
          },
        });
        this.callParent("configure", arguments);
      },

      _focus: function (el) {
        fox.dom.removeClass("error", el.parentNode);
        this.getParent().dom1('[error-alias="' + el.name + '"]').innerHTML = "";
      },

      _submit: function (data) {
        this.wom1("#changePasswordApi")
          .psend(data)
          .then((resp) => {
            $("#message")
              .show()
              .text("Your password was successfully changed.");
          })
          .catch((error) => this.handleError(error));
      },

      handleResponse: function (resp) {},

      handleError: function (resp) {
        var answer = resp.params.answer;
        var code = answer.code;
        var name = null;
        var parent = this.getParent();

        switch (code) {
          case 1:
            name = "newPassword";
            break;
          case 2:
            name = "newPasswordCheck";
            break;
          case 3:
            name = "oldPassword";
            break;
        }

        if (!name) {
          console.warn(
            "no name for code -> ",
            code,
            "reason -> ",
            answer.reason
          );
        }

        fox.dom.addClass(
          "error",
          parent.dom1('[name="' + name + '"]').parentNode
        );
        parent.dom1('[error-alias="' + name + '"]').innerHTML = answer.reason;
      },

      _validate: (data) => {
        var parent = fox.wom.selectFirst("~#settingsForm").getParent();
        fox.each(data, function (val, alias) {
          if (val.result === false) {
            var name = val.field;
            var errMessage = val.message;
            fox.dom.addClass(
              "error",
              parent.dom1('[name="' + name + '"]').parentNode
            );
            parent.dom1('[error-alias="' + name + '"]').innerHTML = errMessage;
          }
        });
      },
    },
    "Site_Page"
  );
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/account.js
// module id = 907
// module chunks = 4